import React from "react";
import { ArrowRight, Check, Lock, Sparkles } from "lucide-react";
import { THEMES, TIERS_WITH_THEMES, StepTitle, fmtEur, priceFor, effectiveTier } from "./shared";

const ThemeCard = ({ theme, selected, locked, onPick }) => {
  const Icon = theme.icon;
  return (
    <button
      type="button"
      data-testid={`sw-theme-${theme.key}`}
      aria-pressed={selected}
      disabled={locked}
      onClick={() => onPick(selected ? null : theme.key)}
      className={`sw-option sw-theme ${selected ? "is-selected" : ""}`}
      style={selected ? { background: theme.color, borderColor: theme.accent } : undefined}
    >
      <span className="sw-theme__icon" style={{ color: theme.accent, background: selected ? "rgba(255,255,255,0.7)" : theme.color }}>
        <Icon size={22} />
      </span>
      <span className="sw-option__title" style={{ marginTop: 14 }}>{theme.name}</span>
      <span className="sw-option__sub">{theme.line}</span>
      {selected && <span className="sw-theme__check" style={{ background: theme.accent }}><Check size={13} /></span>}
      {locked && <span className="sw-theme__lock"><Lock size={12} /> Premium</span>}
    </button>
  );
};

const UpgradeHint = ({ quote, onUpgrade }) => (
  <div className="sw-upgrade" data-testid="sw-theme-upgrade">
    <Sparkles size={18} style={{ color: "var(--sw-gold)", flexShrink: 0 }} />
    <div style={{ flex: 1 }}>
      <strong>Thema's horen bij Premium en Bovenklasse.</strong>
      <div style={{ fontSize: 13, color: "var(--sw-ink-soft)" }}>
        Upgrade voor {fmtEur(priceFor(quote, "premium"))} en kies je sfeer.
      </div>
    </div>
    <button type="button" className="sw-chip sw-chip--active" data-testid="sw-theme-upgrade-btn" onClick={onUpgrade}>
      Upgrade
    </button>
  </div>
);

export const Step3Theme = ({ state, update, quote, onNext }) => {
  const tier = effectiveTier(state);
  const locked = !TIERS_WITH_THEMES.has(tier);
  const canUpgrade = locked && tier === "comfort";
  const theme = locked ? null : state.theme;

  return (
    <div className="sw-slide-right">
      <StepTitle title="Kies je thema" sub="Optioneel. De chauffeur stemt muziek, temperatuur en gesprek erop af." />
      {canUpgrade && <UpgradeHint quote={quote} onUpgrade={() => update({ tier: "premium" })} />}
      <div className="sw-theme-grid">
        {THEMES.map((t) => (
          <ThemeCard key={t.key} theme={t} selected={theme === t.key} locked={locked} onPick={(k) => update({ theme: k })} />
        ))}
      </div>
      <button type="button" className="sw-btn sw-btn--block" data-testid="sw-step3-next" onClick={onNext} style={{ marginTop: 24 }}>
        {theme ? "Verder" : "Verder zonder thema"} <ArrowRight size={18} />
      </button>
    </div>
  );
};

export default Step3Theme;
